import { mergeWith } from "lodash";
import { addDropdownStyles } from "@collectivehealth/dls-dropdowns";
import epFilter from "./epFilter.css";
import inlineDropdownTheme from "@collectivehealth/dls-dropdowns/dist/dropdown-theme-select-inline.css";

const mergeFn = (objValue = "", srcValue = "") => {
  return `${objValue} ${srcValue}`;
};

addDropdownStyles([
  {
    attributeName: "theme",
    attributeValue: "ep-filter",
    className: "ignore",
    styles: `${inlineDropdownTheme.toString()} ${epFilter.toString()}`,
    parts: mergeWith(inlineDropdownTheme.locals, epFilter.locals, mergeFn),
    variations: {
      bottom: epFilter.locals.bottom,
      open: epFilter.locals.open
    }
  }
]);
